import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import { MainWidgetTextField } from 'views/common/components/UI/MainWidget';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { PickersDay } from '@mui/x-date-pickers';
import React from 'react';
// import { PickersDay } from '@mui/x-date-pickers';
import { Box } from '@mui/material';

export const COLORS = {
  low: '#767C51',
  medium: '#C19445',
  high: '#A6001E',
};

export const StyledFooterBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 2, 1),
  borderTop: `1px solid ${theme.palette.grey[50]}`,
  '& .LDBColorKeyContainer': {
    display: 'flex',
    gap: theme.spacing(1),
  },
  '& .LDBColorCaption': {
    fontSize: theme.typography.pxToRem(12),
    marginTop: theme.spacing(1),
  },
}));

export const StyledColorBox = styled(Box)(({ theme, variant }) => ({
  backgroundColor: COLORS[variant],
  borderRadius: theme.spacing(0.5),
  color: theme.palette.common.white,
  fontWeight: 'bold',
  padding: theme.spacing(0.8125, 1.625),
}));
export const StyledMainWidgetTextField = styled(MainWidgetTextField)(
  ({ theme }) => ({
    '& .MuiInputBase-input.MuiFilledInput-input': {
      paddingLeft: `${theme.spacing(6.2)} !important`,
    },
    '& .MuiInputAdornment-root': {
      display: 'none',
    },
    '& .MuiFilledInput-root': {
      '&.Mui-disabled': {
        backgroundColor: `${theme.palette.action.disabledBackground} !important`,
      },
    },
  }),
);

export const StyledMuiDatePicker = ({ whiteLabelWidget, ...props }) => {
  const newTheme = (theme) => {
    const baseTheme = {
      ...theme,
      components: {
        MuiPickersPopper: {
          styleOverrides: {
            root: {
              '& .MuiPickersLayout-root': {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              },
            },
          },
        },
        MuiPickersDay: {
          styleOverrides: {
            root: {
              fontSize: theme.typography.pxToRem(14),
              fontWeight: 400,
              '&.Mui-selected': {
                backgroundColor: `${theme.palette.primary.contrastText} !important`,
                color: `${theme.palette.common.white} !important`,
                fontWeight: 600,
              },
            },
          },
        },
        MuiDayCalendar: {
          styleOverrides: {
            weekDayLabel: {
              fontSize: theme.typography.pxToRem(14),
              fontWeight: 700,
            },
          },
        },
        MuiPickersToolbar: {
          styleOverrides: {
            root: {
              display: 'none',
            },
          },
        },
      },
    };

    if (whiteLabelWidget) {
      baseTheme.components.MuiDialog = {
        styleOverrides: {
          paper: {
            height: 'auto',
            maxHeight: `calc(100% - ${theme.spacing(1)})`,
            maxWidth: 'unset',
            '& .MuiPickersSlideTransition-root': {
              minHeight: theme.spacing(28.75),
            },
            '& .MuiPickersLayout-root': {
              height: '100%',
            },
            '& .MuiPickersCalendarHeader-root': {
              marginTop: theme.spacing(1),
              marginBottom: theme.spacing(1),
            },
            '& .MuiDialogActions-root': {
              paddingTop: theme.spacing(0.5),
              paddingBottom: theme.spacing(0.5),
            },
          },
        },
      };
    }

    return createTheme(baseTheme);
  };

  return (
    <ThemeProvider theme={newTheme}>
      {whiteLabelWidget ? (
        <MobileDatePicker {...props} />
      ) : (
        <MuiDatePicker {...props} />
      )}
    </ThemeProvider>
  );
};

export const StyledPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== 'highlightLevel',
})(({ highlightLevel, theme }) => ({
  ...(highlightLevel === 'low' && {
    backgroundColor: COLORS.low,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: `${COLORS.low}cc`,
    },
  }),
  ...(highlightLevel === 'medium' && {
    backgroundColor: COLORS.medium,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: `${COLORS.medium}cc`,
    },
  }),
  ...(highlightLevel === 'high' && {
    backgroundColor: COLORS.high,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: `${COLORS.high}cc`,
    },
  }),
}));
